<template>
  <div class="drop">
    <div class="drop-zone"
         v-bind:style="dropStyle"
         @drop.prevent="fileDropped"
         @dragover.prevent="fileOver"
         @dragleave="fileLeave">
      <div class="plus-sign" v-if="!showImage">{{loadPercent}}</div>
      <div class="image" v-bind:style="imageStyle" v-if="showImage"></div>
    </div>

    <div class="drop__label">
    {{label}}
    </div>
  </div>
</template>

<script type="text/javascript">
  import axios from 'axios';

  export default {
    name: 'drop-zone',
    props: {
      id: {
        type: Number,
        required: true,
      },
      productId: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: '',
      },
      initImage: {
        type: String,
        required: false,
        default: '',
      },
    },
    methods: {
      fileDropped(event) {
        this.dropStyle.background = 'white';
        const file = event.dataTransfer.files[0];

        const data = new FormData();
        data.append('product', this.productId);
        data.append('photo', file);
        data.append('side', this.type);

        const self = this;
        axios.post('/api/productphoto/', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress(progressEvent) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if (percentCompleted === 100) {
              const reader = new FileReader();
              // Closure to capture the file information.
              reader.onload = (theFile) => {
                self.imageSrc = theFile.target.result;
                self.showImage = true;
              };
              reader.readAsDataURL(file);
            } else {
              self.loadPercent = `${percentCompleted}%`;
            }
          },
        }).then((response) => {
          response.image = this.imageSrc;
          self.$emit('uploaded', response);
        });
      },
      fileOver() {
        this.dropStyle.background = '#ccc';
      },
      fileLeave() {
        this.dropStyle.background = '';
      },
      delete() {
        axios.delete('/api/productphoto/', { id: this.id }).then(() => {
          this.imageStyle.backgroundImage = '';
          this.showImage = false;
        });
      },
    },
    watch: {
      initImage() {
        if (this.initImage) {
          this.imageSrc = this.initImage;
        }
      },
      imageSrc() {
        this.imageStyle.backgroundImage = `url(${this.imageSrc})`;
        this.showImage = true;
        this.dropStyle.backgroundColor = 'white';
      },
    },
    data() {
      return {
        dropStyle: { background: '' },
        imageStyle: { backgroundImage: '', backgroundSize: 'contain' },
        imageSrc: this.initImage,
        showImage: false,
        loadPercent: '+',
      };
    },
  };
</script>


<style type="text/css" scoped>
  .drop{
    display: inline-block;
    width: 75px;
    vertical-align: top;
    margin: 0 9px 10px;
  }


  .drop-zone{
    width: 75px;
    height: 75px;
    border: 1px solid #DFDFDF;
    position: relative;
    text-align: center;
    cursor: pointer;
    background: #DFDFDF;
    border-radius: 8px;


  }
  .drop-zone:hover{
    background: #ccc;
  }


  .plus-sign{
    position: absolute;
    z-index: 2;
    top:0;
    bottom: 0;
    left:0;
    right:0;
    font-size: 36px;
    line-height: 80px;
    color:#FFF;
  }

  .image{
    position: absolute;
    z-index: 2;
    top:-2px;
    bottom: -2px;
    left:-2px;
    right:-2px;
    background: center no-repeat;
    margin: 10px;

  }


  .drop__label{
    font-size: 12px;
    line-height: 16px;
    padding-top: 4px;
  }
</style>


// WEBPACK FOOTER //
// DropZone.vue?6fb4a1d0